import React, { Component } from 'react';
import CollapsibleContext from './CollapsibleContext';

class Content extends Component {
  render() {
    const { className } = this.props;
    return (
      <CollapsibleContext.Consumer>
        {({ open }) => (
          <div className={`collapsible-content ${className}`}>
            {open ? this.props.children : null}
          </div>
        )}
      </CollapsibleContext.Consumer>
    );
  }
}

export default Content;
